import {RULES_SMS_INFO} from '../../config/routes';

export const ShortRulesSmsInfo = () => {

    // window.location. = SHORT_RULES_SMS_INFO;
    window.location.href = RULES_SMS_INFO;

    return null;
}